import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { allowedCellContentTypes } from '../utils/allowedPropTypes';
import DataDefinitionList from './_DataDefinitionListController';
import DefinitionTerm from './_DefinitionTerm';
import DefinitionDescription from './_DefinitionDescription';

const processNestedArray = function (nestedArray, receivedPropsDescription, receivedPropsList) {
  const descriptionProps = Object.assign({}, receivedPropsDescription);
  const listProps = Object.assign({}, receivedPropsList);
  let hasNestedDefinitionList = false;

  const processedArray = nestedArray.map(nestedItem => {
    let output = null;
    descriptionProps.key = uuidv4();


    // Return regular definition element if the nested item is renderable:
    const isRenderable = (
      typeof (nestedItem) === 'number'
      || typeof (nestedItem) === 'string'
      || nestedItem.$$typeof !== undefined
    );

    if (isRenderable) {
      output = <DefinitionDescription {...descriptionProps}>{nestedItem}</DefinitionDescription>;
    }

    // Check if the object item is an array:
    else if (Array.isArray(nestedItem)) {
      const processedNestedArrayData = processNestedArray(
        nestedItem,
        descriptionProps,
        listProps
      );

      output = processedNestedArrayData.processedArray;
    }

    // Otherwise it must be a JSON child:
    else {
      hasNestedDefinitionList = true;
      listProps.listData = nestedItem;
      descriptionProps.hasNestedDefinitionList = hasNestedDefinitionList;

      output = (
        <DefinitionDescription {...descriptionProps}>
          <DataDefinitionList {...listProps} />
        </DefinitionDescription>
      );
    }

    return output;
  });

  return {
    hasNestedDefinitionList,
    processedArray
  };
};

const OutputProcessor = (
  {
    definitionTerm,
    definitionDescription,
    preprocessDefinitionTerms,
    preprocessNestingTerms,
    preprocessDefinitionDescriptions
  }
) => {
  const termProps = {
    preprocessDefinitionTerms,
    preprocessNestingTerms,
    hasNestedDefinitionList: false
  };

  const descriptionProps = { preprocessDefinitionDescriptions };
  let descriptionValue = definitionDescription;

  switch (typeof (definitionDescription)) {
    case 'object': {
      // Return regular definition element if the object value is a React element:
      if (definitionDescription.$$typeof !== undefined) {
        break;
      }

      const listProps = {
        preprocessDefinitionTerms,
        preprocessNestingTerms,
        preprocessDefinitionDescriptions,
        listData: definitionDescription
      };

      // Check if the object value is an array:
      if (Array.isArray(definitionDescription)) {
        const processedArrayData = processNestedArray(definitionDescription, descriptionProps, listProps);

        if (processedArrayData.hasNestedDefinitionList) {
          termProps.hasNestedDefinitionList = true;
        }

        return (
          <div className='definition-wrapper' key={uuidv4()}>
            <DefinitionTerm {...termProps}>{definitionTerm}</DefinitionTerm>
          </div>
        );
      }

      // Return a nested definition list because the value must be JSON:
      termProps.hasNestedDefinitionList = true;
      descriptionProps.hasNestedDefinitionList = true;
      descriptionValue = <DataDefinitionList {...listProps} />;
      break;
    }

    case 'string':
      break;

    default:
      descriptionValue = definitionDescription.toString();
  }

  return (
    <div className='definition-wrapper' key={uuidv4()}>
      <DefinitionTerm {...termProps}>{definitionTerm}</DefinitionTerm>
      <DefinitionDescription {...descriptionProps}>{descriptionValue}</DefinitionDescription>
    </div>
  );
};

OutputProcessor.propTypes = {
  preprocessDefinitionTerms: PropTypes.func,
  preprocessNestingTerms: PropTypes.func,
  preprocessDefinitionDescriptions: PropTypes.func,
  definitionTerm: PropTypes.string.isRequired,
  definitionDescription: PropTypes.oneOfType([
    ...allowedCellContentTypes,
    PropTypes.object,
    PropTypes.bool
  ])
};

export default OutputProcessor;